/**
 * @flow
 * @relayHash 95b04d522c266550b9717c90ce5c68a2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CityUpdateInput = {|
  id: string,
  name: string,
  zipCode: string,
  countryId: string,
  governorateId: string,
|};
export type UpdateCityMutationVariables = {|
  data: CityUpdateInput
|};
export type UpdateCityMutationResponse = {|
  +updateCity: {|
    +id: string
  |}
|};
export type UpdateCityMutation = {|
  variables: UpdateCityMutationVariables,
  response: UpdateCityMutationResponse,
|};
*/


/*
mutation UpdateCityMutation(
  $data: CityUpdateInput!
) {
  updateCity(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "CityUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCity",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "CityModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCityMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCityMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCityMutation",
    "id": null,
    "text": "mutation UpdateCityMutation(\n  $data: CityUpdateInput!\n) {\n  updateCity(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a94d96349d3eef9a7615ffd987c947a1';
module.exports = node;
